module.exports = __webpack_public_path__ + "static/Canela-Thin-Web-4f52b41f8e37d821df0229d655eaa90b.woff";